module.exports = __webpack_public_path__ + "32ee0167bb37cb40f57be9a69448149b.png";